import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, DestroyRef, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize } from 'rxjs/operators';
import { PlayerFavouriteViewModel } from '../../../shared/models/PlayerFavouriteModels';
import { PositionPipe } from '../../../shared/pipes/position.pipe';
import { PlayerService } from '../../../shared/services/player.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-favourite-players',
  imports: [CommonModule, RouterLink, MatButtonModule, MatIconModule,
     MatProgressSpinnerModule, MatToolbarModule, PositionPipe, TranslatePipe],
  templateUrl: './favourite-players.component.html',
  styleUrl: './favourite-players.component.css'
})
export class FavouritePlayersComponent implements OnInit {
  players: PlayerFavouriteViewModel[] = [];
  isLoading = false;
  loadError = false;
  private cdr = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);

  constructor(private readonly playerService: PlayerService) {}

  ngOnInit(): void {
    this.loadFavourites();
  }

  loadFavourites(): void {
    this.isLoading = true;
    this.loadError = false;

    this.playerService.getFavourites()
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          this.isLoading = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe({
        next: (result) => {
          this.players = result ?? [];
          this.cdr.detectChanges();
        },
        error: () => {
          this.players = [];
          this.loadError = true;
          this.cdr.detectChanges();
        }
      });
  }

  getPlayerId(item: PlayerFavouriteViewModel): string {
    return item.PlayerView?.PlayerId ?? item.PlayerId ?? item.Player?.LifelineScoutingId ?? '';
  }

  getPlayerName(item: PlayerFavouriteViewModel): string {
    const lastName = item.PlayerView?.LastName ?? item.Player?.LastName ?? '';
    const firstName = item.PlayerView?.FirstName ?? item.Player?.FirstName ?? '';
    return `${lastName}, ${firstName}`.trim();
  }

  getPositionId(item: PlayerFavouriteViewModel): number {
    return item.PlayerView?.PositionId ?? item.Player?.PositionId ?? 0;
  }

  getDivisionName(item: PlayerFavouriteViewModel): string {
    return item.DivisionName ?? item.Player?.Division ?? '';
  }

  getTeamName(item: PlayerFavouriteViewModel): string {
    return item.Player?.CurrentTeam ?? '';
  }

  getGamesCount(item: PlayerFavouriteViewModel): number {
    return item.LatestGames?.length ?? 0;
  }

  getReportsCount(item: PlayerFavouriteViewModel): number {
    return item.LatestReports?.length ?? 0;
  }
}